import { format } from 'date-fns';

import isValidDate from './is-valid-date';

const formatDateWithMonth = (date) => (isValidDate(date) ? format(date, 'MMMM yyyy') : 'Present');

export default formatDateWithMonth;
